export default {
  MLA: {
    name: 'MLA (Modern Language Association)',
    id: 'mla',
    type: 'Journal',
    templateId: 'MLA',
    acronym: 'MLA',
    refStyle: 'modern-language-association.csl',
    refLocale: 'locales-en-US.xml',
  },
  IEEE: {
    name: 'IEEE - Generic One Column',
    id: 'ieee',
    type: 'Journal',
    templateId: 'IEEE',
    acronym: 'IEEE',
    refStyle: 'ieee.csl',
    refLocale: 'locales-en-US.xml',
  },
  APA: {
    name: 'APA (American Psychological Association)',
    id: 'apa',
    type: 'Journal',
    templateId: 'APA',
    acronym: 'APA',
    refStyle: 'apa.csl',
    refLocale: 'locales-en-US.xml',
  },
};
